// extracted by mini-css-extract-plugin
export default {"container":"GrossMarginContainer_container__U8SLb"};